module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.fee66e7.woff";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff
// module id = 2230
// module chunks = 1